import Vue from 'vue'
import PhoneFieldComponent from './components/PhoneFieldComponent'
import { ValidationObserver, ValidationProvider, extend, localize } from 'vee-validate';
import en from 'vee-validate/dist/locale/en.json';
import * as rules from 'vee-validate/dist/rules';
import { configure } from 'vee-validate';
//import VeeValidate from 'vee-validate';


// import { required, email, alpha} from 'vee-validate/dist/rules';

import App from './App.vue'

configure({
  classes: {
    valid: 'valid',
    invalid: 'invalid',
    dirty: ['dirty', 'dirty'], // multiple classes per flag!
  }
})

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});
localize('en', en);

localize({
  en: {
    messages: {
      length : 'ошибка в номере',
      required: 'это поле обязательно для заполнения',
      alpha: 'ошибка, только буквы',
      alpha_spaces: 'ошибка, только буквы',
      email: 'ошибка'
    }
  }
});


Vue.component('PhoneFieldComponent', PhoneFieldComponent);
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);


Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
